import { render } from "./CalendarButton.vue?vue&type=template&id=bfd965e8"
import script from "./CalendarButton.vue?vue&type=script&lang=js"
export * from "./CalendarButton.vue?vue&type=script&lang=js"

import "./CalendarButton.vue?vue&type=style&index=0&id=bfd965e8&lang=css"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__